import React from "react";
import { Bike, Loader2 } from "lucide-react";

interface ChamarProximoButtonProps {
  disabled: boolean;
  loading?: boolean;
  onClick: () => void;
  compact?: boolean;
}

const ChamarProximoButton: React.FC<ChamarProximoButtonProps> = ({
  disabled,
  loading = false,
  onClick,
  compact = false,
}) => {
  if (compact) {
    return (
      <button
        type="button"
        onClick={onClick}
        disabled={disabled || loading}
        className="flex w-full items-center justify-center gap-2 rounded-lg bg-primary px-3 py-2.5 text-sm font-bold text-white shadow transition-colors hover:bg-primary-dark disabled:cursor-not-allowed disabled:bg-neutral-400"
      >
        {loading ? (
          <Loader2 size={18} className="animate-spin" />
        ) : (
          <Bike size={18} />
        )}
        {loading ? "Chamando..." : "Chamar Entregador"}
      </button>
    );
  }

  return (
    <div className="flex justify-start">
      <button
        type="button"
        onClick={onClick}
        disabled={disabled || loading}
        className="flex items-center gap-3 rounded-lg bg-primary px-8 py-4 text-lg font-bold text-white shadow-lg transition-all hover:scale-105 hover:bg-primary-dark hover:shadow-xl disabled:cursor-not-allowed disabled:bg-neutral-400 disabled:hover:scale-100 disabled:hover:shadow-lg"
      >
        {loading ? (
          <Loader2 size={24} className="animate-spin" />
        ) : (
          <Bike size={24} />
        )}
        {loading ? "Chamando..." : "Chamar Entregador"}
      </button>
    </div>
  );
};

export default ChamarProximoButton;
